import { Metaballs } from '../../MetaballsGooey';
import NextImage from '../../NextImage';
import { ImagesService } from 'service/images/imagesService';
import { ICardImage } from '../types';

export const CardImageMetaBall = ({ asset }: ICardImage) => {
  if (!asset) {
    return null;
  }

  return (
    <div className="max-h-96 overflow-hidden">
      <div className="absolute w-full h-3/4 pt-10">
        <Metaballs duration={10} color="#DFF0D1" />
      </div>
      <NextImage
        className="h-72 mx-auto relative"
        sources={ImagesService.getPictureSources(asset)}
        alt=""
      />
    </div>
  );
};
